import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface VerificationState {
  email_verify_completed: boolean | null
  mobile_verify_completed: boolean | null
  pin_setup: boolean | null
  security_question_setup: boolean | null
  personal_data_completed: boolean | null
  contact_data_completed: boolean | null
  representative_data_completed: boolean | null
  business_info_data_completed: boolean | null
  checker_confirm: boolean | null
  usertype: number | null
  kycLevel: number | null
  country: string | null
}

const initialState: VerificationState = {
  email_verify_completed: null,
  mobile_verify_completed: null,
  pin_setup: null,
  security_question_setup: null,
  personal_data_completed: null,
  contact_data_completed: null,
  representative_data_completed: null,
  business_info_data_completed: null,
  checker_confirm: null,
  usertype: null,
  kycLevel: null,
  country: null,
}

const checkerSlice = createSlice({
  name: "checker",
  initialState,
  reducers: {
    setEmailVerificationStatus: (state, action: PayloadAction<boolean>) => {
      state.email_verify_completed = action.payload
    },
    resetEmailVerification: (state) => {
      state.email_verify_completed = null
    },

    setMobileVerificationStatus: (state, action: PayloadAction<boolean>) => {
      state.mobile_verify_completed = action.payload
    },
    resetMobileVerification: (state) => {
      state.mobile_verify_completed = null
    },

    setPinSetupStatus: (state, action: PayloadAction<boolean>) => {
      state.pin_setup = action.payload
    },
    resetPinSetup: (state) => {
      state.pin_setup = null
    },

    setSecurityQuestionSetupStatus: (state, action: PayloadAction<boolean>) => {
      state.security_question_setup = action.payload
    },
    resetSecurityQuestionSetup: (state) => {
      state.security_question_setup = null
    },

    setPersonalDataCompletedStatus: (state, action: PayloadAction<boolean>) => {
      state.personal_data_completed = action.payload
    },
    resetPersonalDataCompleted: (state) => {
      state.personal_data_completed = null
    },

    setContactDataCompletedStatus: (state, action: PayloadAction<boolean>) => {
      state.contact_data_completed = action.payload
    },
    resetContactDataCompleted: (state) => {
      state.contact_data_completed = null
    },

    setRepresentativeDataCompletedStatus: (state, action: PayloadAction<boolean>) => {
      state.representative_data_completed = action.payload
    },
    resetRepresentativeDataCompleted: (state) => {
      state.representative_data_completed = null
    },

    setBusinessInfoDataCompletedStatus: (state, action: PayloadAction<boolean>) => {
      state.business_info_data_completed = action.payload
    },
    resetBusinessInfoDataCompleted: (state) => {
      state.business_info_data_completed = null
    },

    setCheckerStatus: (state, action: PayloadAction<boolean>) => {
      state.checker_confirm = action.payload
    },
    setSetUsertype: (state, action: PayloadAction<number>) => {
      state.usertype = action.payload
    },
    setKycLevel: (state, action: PayloadAction<number>) => {
      state.kycLevel = action.payload
    },
    setCountry: (state, action: PayloadAction<number>) => {
      state.kycLevel = action.payload
    },
    clearAllChecks: (state) => {
      state.email_verify_completed = null
      state.mobile_verify_completed = null
      state.pin_setup = null
      state.security_question_setup = null
      state.personal_data_completed = null
      state.contact_data_completed = null
      state.representative_data_completed = null
      state.business_info_data_completed = null
      state.checker_confirm = null
      state.usertype = null
      state.kycLevel = null
      state.country = null
    },
  },
})

export const {
  setEmailVerificationStatus,
  resetEmailVerification,
  setMobileVerificationStatus,
  resetMobileVerification,
  setPinSetupStatus,
  resetPinSetup,
  setSecurityQuestionSetupStatus,
  resetSecurityQuestionSetup,
  setPersonalDataCompletedStatus,
  resetPersonalDataCompleted,
  setContactDataCompletedStatus,
  resetContactDataCompleted,
  setRepresentativeDataCompletedStatus,
  resetRepresentativeDataCompleted,
  setBusinessInfoDataCompletedStatus,
  resetBusinessInfoDataCompleted,
  setCheckerStatus,
  setSetUsertype,
  setKycLevel,
  setCountry,
  clearAllChecks, // Exported clearAllChecks action
} = checkerSlice.actions

export default checkerSlice.reducer
